import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';
import { LabeledCheckboxProps } from '../../components/LabeledCheckbox';
import { FetchingPageDialog, useOpenFetchingPageDialog } from '../../components/PageDialog';
import { MarkdownContent } from './MarkdownContent';

type Props = Omit<LabeledCheckboxProps, 'label'>

// Todo: this is not an checkbox anymore
export const ConsentCheckbox = React.forwardRef<HTMLInputElement, Props>(({ ...props }, ref) => {
  const { t, i18n } = useTranslation();

  const openDialog = useOpenFetchingPageDialog();

  const onTos = (e: React.MouseEvent) => {
    e.preventDefault();
    openDialog({
      title: t('checkout.purchaser_form.consent.tos_title'),
      url: `/docs/tos-purchase-${i18n.language}.md`,
    });
  };

  const onRevocation = (e: React.MouseEvent) => {
    e.preventDefault();
    openDialog({
      title: t('checkout.purchaser_form.consent.revocation_title'),
      url: `/docs/revocation-${i18n.language}.md`,
    });
  };

  return (
    <>
      <Typography style={{ alignSelf: 'center' }} variant={'caption'} color={'textSecondary'}>
        {t('checkout.purchaser_form.consent.alt_1')}
        <Link href={'#tos'} onClick={onTos}>
          {t('checkout.purchaser_form.consent.tos_2')}
        </Link>
        {t('checkout.purchaser_form.consent.alt_2')}
        <Link href={'#revocation'} onClick={onRevocation}>
          {t('checkout.purchaser_form.consent.revocation_alt')}
        </Link>
        {t('checkout.purchaser_form.consent.alt_3')}
      </Typography>
      <FetchingPageDialog component={MarkdownContent} />
    </>
  );
});
